import Vue from 'vue';

const getDefaultState = function() {
  return {
    /**
     * key: dateTimeMS
     * value: {
     *  @SID {String} session ID
     *  @partnerID partner's ID
     *  @sessionData session's data (worktype, completion % etc)
     * }
     */
    pastMatches: {},
  };
};


const state = getDefaultState();

const getters = {
  
};

const mutations = {
  /**
   * @param {
   *  dateTimeMS, 
   *  SID, // session ID
   *  partnerID,
   *  sessionData
   * } payload 
   * 
   */
  ADD_PAST_MATCH(state, payload) {
    Vue.set(state.pastMatches, payload.dateTimeMS, {
      SID: payload.SID,
      partnerID: payload.partnerID,
      sessionData: payload.sessionData, 
    });
  },
  /**
   * Assumes that the properties dateTimeMS and field exist. Idk if ever needed 
   * @param {
   *  dateTimeMS -- the datetime for which to set the field
   *  field -- field to update 
   *  newValue -- the new value to add
   * }
   * TODO: more specific, also idk if even needed
   */
  UPDATE_PAST_MATCH_FIELD(state, payload) {
    state.pastMatches[payload.dateTimeMS][payload.field] = payload.newValue;
  },

};

const actions = {
  /**
   * @param {
   *  SID,
   *  dateTimeMS,
   *  partnerID,
   *  sessionData // not sure if used anywhere atm
   * }
   * TODO: get preferences
   */
  addPastMatch({commit}, payload) {
    commit("ADD_PAST_MATCH", payload);
  },

  /**
   * @param {
   *  <partnerID>: {
   *    metadata: {Object} partner's metadata
   *    sessions: [{SID, d, current}, ...] Array of sessions with this partner. 
   *  }
   * } pastSessions the past sessions object from DB 
   * SID -- session ID
   * d -- dateTimeMS,
   * session -- current user's session data
   */
  addFromDB({commit, dispatch}, pastSessions) {
    // maybe await? don't think its necessary tho
    /* add all users to calendarUsers */
    dispatch("calendarUsers/setUserMetadataArray", Object.values(pastSessions).map(partner => partner.metadata), {root: true});

    Object.keys(pastSessions).forEach(partnerID => {
      const partnerSessions = pastSessions[partnerID].sessions;
      for (let i=0; i<partnerSessions.length; i++) {
        commit("ADD_PAST_MATCH", {
          dateTimeMS: Number(partnerSessions[i].d),
          SID: partnerSessions[i].SID,
          partnerID,
          sessionData: partnerSessions[i].current
        });
      }
    });
    return true;
  }
};

const pastMatches = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default pastMatches;

